import { useCallback, useEffect, useMemo, useRef } from 'react';

import { LoanSummaryDrilldownParam } from 'constants/loanSummaryDrilldown';
import useQueryFilters from 'hooks/useQueryFilters';
import { parseConditionDrilldown } from 'utils/loanSummaryDrilldown';

const useConditionDrilldown = ({
  statusColumnKey,
  openStatusValues = [],
  availableStatuses = [],
  onColumnFiltersChange,
} = {}) => {
  const { filters, setFilterValue } = useQueryFilters({ filterFields: LoanSummaryDrilldownParam });

  const priorToType = filters[LoanSummaryDrilldownParam.CONDITION_PRIOR_TO];
  const status = filters[LoanSummaryDrilldownParam.CONDITION_STATUS];

  const drilldown = useMemo(
    () => parseConditionDrilldown({ priorToType, status }),
    [priorToType, status],
  );

  const onClearDrilldown = useCallback(() => {
    setFilterValue(LoanSummaryDrilldownParam.CONDITION_PRIOR_TO, null);
    setFilterValue(LoanSummaryDrilldownParam.CONDITION_STATUS, null);
  }, [setFilterValue]);

  const isHandedOver = useRef(false);

  useEffect(() => {
    if (!onColumnFiltersChange || !drilldown || isHandedOver.current || !availableStatuses.length) {
      return;
    }

    isHandedOver.current = true;

    if (drilldown.isOpenOnly && statusColumnKey) {
      const presentValues = openStatusValues.filter(value => availableStatuses.includes(value));

      onColumnFiltersChange(statusColumnKey, {
        values: presentValues.length ? presentValues : openStatusValues,
      });
    }

    onClearDrilldown();
  }, [
    drilldown,
    statusColumnKey,
    openStatusValues,
    availableStatuses,
    onColumnFiltersChange,
    onClearDrilldown,
  ]);

  return { drilldown };
};

export default useConditionDrilldown;
